export default "__VITE_ASSET__CdPqV4Lf__"